
export const DMS_SHARE = [
    {
        id: "FullRight",
        value: 1,
        label: "Full Rights"
    },
    {
        id: "Review",
        value: 2,
        label: "Review"
    },
    {
        id: "View",
        value: 3,
        label: "View"
    },
    {
        id: "Edit",
        value: 4,
        label: "Edit"
    }
]

export const DMS_PERMISSIONS = {
    "FullRight": {
        canView: true,
        canDownload: true,
        canComment: true,
        canUpload: true,
        canDeleteFile: true,
        canDeleteFolder: true,
        canManagePermission: true,
        canAddFolder: true,
        canUploadFolder: true
    },
    "Edit": {
        canView: true,
        canDownload: true,
        canComment: true,
        canUpload: true,
        canDeleteFile: false,
        canDeleteFolder: false,
        canManagePermission: false,
        canAddFolder: true,
        canUploadFolder: true
    },
    "View": {
        canView: true,
        canDownload: false,
        canComment: false,
        canUpload: false,
        canDeleteFile: false,
        canDeleteFolder: false,
        canManagePermission: false,
        canAddFolder: false,
    },
    "Review": {
        canView: true,
        canDownload: true,
        canComment: true,
        canUpload: false,
        canDeleteFile: false,
        canDeleteFolder: false,
        canManagePermission: false,
        canAddFolder: false,
    }
}


export const noAccess = {
    canView: false,
    canDownload: false,
    canComment: false,
    canUpload: false,
    canDeleteFile: false,
    canDeleteFolder: false,
    canManagePermission: false,
    canAddFolder: false,
}

export const getPermissions = (resourceId, resourceType, permissionList = [], email, isAdmin) => {
    //console.log("permissionsss before", resourceId, permissionList, email);
    if (isAdmin) {
        return DMS_PERMISSIONS.FullRight
    }
    if (permissionList?.length === 0) {
        return noAccess
    }
    const findedResource = permissionList.find(item => email === item.userEmail && item.resourceId === resourceId && item.resourceType === resourceType);
    //console.log("permissionsss finded", findedResource)
    if (findedResource) {
        const permissions = DMS_PERMISSIONS[findedResource.permissionType]
        return permissions || noAccess
    }
    return noAccess
}

export const canDeleteSharedPermissions = (resourceId, resourceType, permissionList = [], userEmail, isAdmin) => {
    const perms = getPermissions(resourceId, resourceType, permissionList, userEmail, isAdmin);

    if (!perms.canManagePermission) return false;
    //console.log("updatedList Prev", permissionList)
    const haveDeletePermission = permissionList.some(p => {
        //return p.resourceId === resourceId && p.resourceType === resourceType && p.permissionType !== "FullRight"
        return p.resourceId === resourceId && p.resourceType === resourceType && p.userEmail !== userEmail
    });

    //console.log("updatedList", updatedList)

    return haveDeletePermission
};
